const THREE = window.THREE

let Zone = function (mesh) {
  this.mesh = mesh
  this.zoneIndex = /zone-([0-9a-zA-z.-]*)_/.exec(mesh.name)[1]
  this.mesh.material = new THREE.MeshBasicMaterial({
    visible: false,
    color: 0xffffff
  })
  this.mesh.zoneIndex = this.zoneIndex
  Object.setPrototypeOf(this, mesh)
}

export default Zone



// WEBPACK FOOTER //
// ./src/world/Zone.js